<template>
  <div class="flex flex-col gap-[64px] font-[ProximaNova]">
    <div class="flex flex-col gap-[32px]">
      <h2 class="text-[22px] leading-[26px] font-[600]">
        Service Agreement
      </h2>

      <div class="flex items-center justify-between gap-x-[12px]">
        <span class="text-[16px] leading-[24px] font-[400] text-[#424242] mb-0">
          ESTAGE MASTER SERVICES AGREEMENT (MSA)
        </span>

        <div class="flex items-center gap-x-[16px]">
          <a
            class="text-[16px] leading-[24px] font-[400] text-[#3D82EA] hover:underline"
            href="/pdf/estage-msa-sep-24-2025.pdf"
            target="_blank"
          >
            View
          </a>
          <a
            class="text-[16px] leading-[24px] font-[400] text-[#3D82EA] hover:underline"
            href="/pdf/estage-msa-sep-24-2025.pdf"
            target="_blank"
            download
          >
            Download
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServiceAgreement'
}
</script>